var exports = {
  "q": "x234b8571--af817b--footer",
};

module.exports = exports;
